import React from "react";

const FILES = {
  en: { m: "camcpc-ad-english-vertical-30s", w: "camcpc-ad-english-widescreen-45s" },
  ar: { m: "camcpc-ad-arabic-vertical-30s", w: "camcpc-ad-arabic-widescreen-42s" },
};
const LABEL = {
  en: "Video: how booking with Cambridge Cardiovascular Prevention Clinic works. Captions are shown in the video. Patient scenes are actor portrayals.",
  ar: "فيديو: كيف تحجز موعدًا في عيادة كامبريدج للوقاية من أمراض القلب. الترجمة ظاهرة في الفيديو والمشاهد تمثيلية.",
};

const Player = ({ name, className, label, testId }) => (
  <video controls playsInline preload="none" poster={`/ad-videos/${name}.jpg`} aria-label={label} data-testid={testId}
    className={`w-full rounded-md border border-bronze-light/40 shadow-sm bg-ink ${className}`}>
    <source src={`/ad-videos/${name}.mp4`} type="video/mp4" />
  </video>
);

export const AdVideo = ({ lang = "en" }) => {
  const f = FILES[lang];
  return (
    <div data-testid={`ad-video-${lang}`}>
      <Player name={f.m} className="md:hidden max-w-sm mx-auto aspect-[9/16]" label={LABEL[lang]} testId={`ad-video-${lang}-mobile`} />
      <Player name={f.w} className="hidden md:block aspect-video" label={LABEL[lang]} testId={`ad-video-${lang}-desktop`} />
    </div>
  );
};
